/**
 * Captcha Component
 */
export class Captcha {
    constructor() {
        this.img = null;
        this.refresh = null;
        this.listen = null;
        this.audioEl = null;
        this.listenIcon = null;
        this.isPlaying = false;
    }

    init() {
        this.img = document.getElementById("captcha-img");
        this.refresh = document.getElementById("captcha-refresh");
        this.listen = document.getElementById("captcha-listen");
        this.audioEl = document.getElementById("captcha-audio");

        if (!this.img || !this.refresh || !this.listen || !this.audioEl) return;

        this.listenIcon = this.listen.querySelector("i");
        this.bindEvents();
    }

    bindEvents() {
        this.refresh.addEventListener("click", () => this.refreshCaptcha());
        this.listen.addEventListener("click", () => this.toggleAudio());
        this.refresh.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.refreshCaptcha();
            }
        });
    }

    resetAudio() {
        try {
            this.audioEl.pause();
        } catch (e) {}
        this.audioEl.removeAttribute("src");
        this.audioEl.load();
        this.isPlaying = false;
        if (this.listenIcon) {
            this.listenIcon.classList.remove("fa-volume-slash");
            this.listenIcon.classList.add("fa-volume");
        }
    }

    refreshCaptcha() {
        this.resetAudio();
        this.img.src = "/inc/lib/captcha.image.php?_=" + Date.now();
    }

    async toggleAudio() {
        if (this.isPlaying) {
            this.resetAudio();
            return;
        }

        try {
            this.listen.disabled = true;
            const url = "/inc/lib/captcha.audio.php?_=" + Date.now();

            this.resetAudio();
            this.audioEl.src = url;

            await this.audioEl.play();
            this.isPlaying = true;

            if (this.listenIcon) {
                this.listenIcon.classList.remove("fa-volume");
                this.listenIcon.classList.add("fa-volume-slash");
            }

            this.audioEl.onended = () => {
                this.resetAudio();
            };
        } catch (err) {
            console.error(err);
            alert("오디오를 재생할 수 없습니다.");
            this.resetAudio();
        } finally {
            this.listen.disabled = false;
        }
    }
}

